import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import Box from '@mui/material/Box'
import Snackbar from '@mui/material/Snackbar'
import styled from '@emotion/styled'

import { selectWebview } from 'store/webview/webviewSlice'
import { shareUrlFromNative, copyTextFromNative } from '/utils/native-notifier'
import { LS_APP_DOMAIN } from 'config/constants'
import { copyToClipboard } from 'utils/helpers'
import { ShareSVG, CopySVG } from 'components/common/SVGElements'

const SquareIconButton = styled.div`
  ${({ theme }) => `
    cursor: pointer;
    padding: ${theme.spacing(3)};
    background-color: white;
    border-radius: 10px;
    line-height: 1;
  `}
`

const genLink = (route, photo) => {
  const link = LS_APP_DOMAIN + route
  return photo ? `${link}?photoId=${photo}` : link
}

const ShareAlbum = ({ album, photoUrlId }) => {
  const router = useRouter()
  const [toast, setToast] = useState({ open: false, message: '' })

  const webview = useSelector(selectWebview)

  const onShareClick = async () => {
    const text = album.name
    const url = genLink(router.asPath.split('?')?.[0], photoUrlId)

    if (webview?.name === 'lsApp') {
      shareUrlFromNative(text, url)
    } else {
      const shareData = { title: '信義居家', text, url }
      try {
        await navigator.share(shareData)
        setToast({ open: true, message: '分享成功' })
      } catch (err) {}
    }
  }

  const onCloneLinkClick = () => {
    const link = genLink(router.asPath.split('?')?.[0], photoUrlId)

    if (webview?.name === 'lsApp') {
      copyTextFromNative(link)
      setToast({ open: true, message: '複製完成' })
    } else {
      copyToClipboard(link)
      setToast({ open: true, message: '複製完成' })
    }
  }

  return (
    <>
      <Box mb={2.5}>
        <SquareIconButton onClick={onShareClick}>
          <ShareSVG textSecondary />
        </SquareIconButton>
      </Box>
      <Box>
        <SquareIconButton onClick={onCloneLinkClick}>
          <CopySVG textSecondary />
        </SquareIconButton>
      </Box>
      <Snackbar
        open={toast.open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        message={toast.message}
        onClose={() => setToast({ open: false, message: '' })}
      />
    </>
  )
}

export default ShareAlbum
